export default {
  adMediaHeader: 'Publicité',
  adMediaExternalLink: 'Visiter le lien externe',
  adultContentAccept: 'Afficher le contenu réservé aux adultes',
  adultContentMessage1: "Le contenu auquel vous essayez d'accéder peut inclure des éléments sexuellement explicites et s'adresse à un public adulte. En accédant à ce contenu, vous confirmez que vous êtes majeur selon la loi en vigueur pour consulter des contenus sexuellement explicites, et que vous vous engagez à ne pas le partager avec des mineurs ou des personnes non autorisées à y accéder.",
  adultContentMessage2: "En cliquant sur «Afficher le contenu réservé aux adultes», vous acceptez d'assumer l'entière responsabilité de votre visionnage. Si vous n'êtes pas en âge légal ou si vous préférez ne pas consulter ce contenu, veuillez cliquer sur «Annuler».",
  bookFormLabelKeywords: 'Mots-clés (séparés par une virgule):',
  bookFormLabelMainCategory: 'Catégorie principale:',
  bookFormLabelNbPages: 'Nombre de pages:',
  bookFormLabelShuffleByMostPopular: 'Voir les plus populaires en premier',
  bookFormLabelSortByNewest: 'Afficher les nouveautés en premier',
  bookFormLabelSubcategory: 'Sous-catégorie:',
  bookFormLabelYears: 'Années de publication:',
  bookFormText1: 'Choisissez une catégorie pour recevoir des suggestions de livres aléatoires:',
  bookFormText2: 'Sélectionnez ensuite une sous-catégorie:',
  bookFormText3: 'Vous pouvez aussi ajouter des filtres facultatifs.',
  bookHeaderAudience: 'Public cible',
  bookHeaderAuthorBio: "À propos de l'auteur",
  bookHeaderCollection: 'Collection',
  bookHeaderDimensions: 'Dimensions',
  bookHeaderImages: 'Aperçu',
  bookHeaderLanguage: 'Langue',
  bookHeaderNbPages: 'Impression',
  bookHeaderPublicationDate: 'Date de parution',
  bookHeaderPublisher: 'Éditeur',
  bookHeaderSellers: 'Voir sur',
  bookHeaderSeries: 'Série',
  bookHeaderSocial: "Suivez l'auteur!",
  bookReadAnExcerpt: 'Feuilleter un extrait',
  bookTextCollection1: 'Livre de la collection ',
  bookTextCollection2: " de l'éditeur ",
  bookTextSeries1: 'Livre ',
  bookTextSeries2: 'de la série ',
  buttonAccept: 'Accepter',
  buttonBack: 'Retour',
  buttonCancel: 'Annuler',
  buttonClose: 'Fermer',
  buttonDelete: 'Supprimer',
  buttonDownload: 'Télécharger',
  buttonSave: 'Sauvegarder',
  buttonUpload: 'Charger',
  cookieConsentAccept: 'Accepter tous les cookies',
  cookieConsentRefuse: 'Tout refuser',
  cookieConsentText1: 'Ce site utilise des cookies pour analyser le trafic. Pour plus de détails, lisez nos politiques ',
  cookieConsentText2: 'ici.',
  fileLikedBooks: 'mes-livres-aimés',
  filterHeader: 'Filtres de recherche',
  footer1: 'Propulsé avec du cœur ❤️, du café ☕ et par ',
  footer2: 'Un Simple Tigre',
  footer3: '.',
  generalAdultContent: 'Contenu adulte',
  generalAttention: 'Attention',
  generalClickToDisplay: 'Cliquer pour afficher',
  generalLinkCopied: 'Lien copié!',
  generalNoOptions: 'Aucune option disponible',
  generalWattpadBook: 'Livre Wattpad',
  homeFooter1: 'Fait au Québec ⚜️ par ',
  homeFooter2: 'Un Simple Tigre',
  homeFooter3: '.',
  homeSubheader11: 'Trouve ton',
  homeSubheader12: 'match litteraire!',
  homeSubheader21: 'Le savoir,',
  homeSubheader22: "c'est le pouvoir!",
  homeSubheader31: 'Quel est ton',
  homeSubheader32: 'crush litteraire?',
  homeSubheader41: 'Ta passion, ton livre,',
  homeSubheader42: 'ton univers!',
  homeSubheader51: 'Chasse au',
  homeSubheader52: 'tresor litteraire!',
  homeSubheader61: 'Ouvre un livre,',
  homeSubheader62: 'eveille des passions!',
  homeSubheader71: "Trouve l'amour",
  homeSubheader72: 'entre les lignes!',
  inputMax: 'max',
  inputMin: 'min',
  inputSelect: 'Sélectionnez...',
  likesHeader: 'Livres aimés',
  likesInfo: "Les livres aimés resteront sauvegardés dans la cache, même si vous fermez la page ou l'application.",
  likesQuestionDeletion: 'Êtes-vous sûr de vouloir enlever ce livre?',
  noResultSearch: 'Aucun résultat trouvé.',
  noResultSliding: "L'étagère est vide.",
  noResultEnd: 'Veuillez relancer une recherche.',
  pageNotFound: 'Oups! Je ne trouve pas la page que vous cherchez.',
  pages: 'pages',
  pageCollectionHeader1: 'La collection',
  pageCollectionHeader2: "de l'éditeur ",
  pageSeriesHeader: 'La série',
  seeAll: 'Tout voir',
  seeBrowse: 'Parcourir',
  seeLess: 'En voir moins',
  seeMore: 'En voir plus',
  tooltipBack: 'Retour',
  tooltipDislike: 'Passer',
  tooltipHome: 'Accueil',
  tooltipLike: "J'aime",
  tooltipSearch: 'Rechercher',
  tooltipShare: 'Partager',
  websiteName: 'Bookyverse',
  ratingAccordingTo: "D'après les internautes de",
  settingsAdultContent: 'Afficher le contenu réservé aux adultes',
  settingsCookieConsent: 'Accepter tous les cookies',
  settingsHeader: 'Paramètres',
  settingsLanguage: 'Langue',
  settingsTutorial: 'Revoir le tutoriel',
  tutorialAccept: 'OK, je suis prêt!',
  tutorialDislikeButton: 'Passer au livre suivant.',
  tutorialFilterIcon: 'Accéder aux filtres de recherche ou lancer une nouvelle recherche.',
  tutorialHeader: 'Tutoriel',
  tutorialLikeButton: "Aimer le livre et l'ajouter aux livres aimés.",
  tutorialListOfLikesIcon: 'Accéder aux livres aimés.',
  tutorialShareButton: 'Obtenir le lien du livre pour le partager.',
  tutorialText: "Pour comprendre cette page, lisez attentivement le contenu des bulles d'information.",
};
